import {arrayToSet} from '../../atUtils'
import View from '../../View'

export class FeatureDiffController extends View {
    constructor({
        handledFeatures = [],
        onFeaturesChanged = () => {},
    }) {
        super()

        this.params = {
            handledFeatures: arrayToSet(handledFeatures),
            onFeaturesChanged,
        }

        this.state = {
            features: null,
        }

        this.onStatePropertyDeeplyChanged('features', (features, prevFeatures) => {
            if (prevFeatures) {
                this._handleFeatureChanges(prevFeatures, features)
            }
        })
    }

    _handleFeatureChanges(prevFeatures, features) {
        const allFeatures = {
            ...prevFeatures,
            ...features
        }

        const changedFeatures = {}

        Object.keys(allFeatures)
              .filter(feature => this.params.handledFeatures[feature] && !!prevFeatures[feature] !== !!features[feature])
              .forEach(feature => changedFeatures[feature] = !!features[feature])

        if (Object.keys(changedFeatures).length > 0) {
            this.params.onFeaturesChanged(changedFeatures)
        }
    }
}



// WEBPACK FOOTER //
// ./web/js/features/components/FeatureDiffController.js